var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_314_27583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8573 5.64514H11.143C10.1962 5.64514 9.42871 6.41265 9.42871 7.35943V15.0737C9.42871 16.0205 10.1962 16.788 11.143 16.788H18.8573C19.8041 16.788 20.5716 16.0205 20.5716 15.0737V7.35943C20.5716 6.41265 19.8041 5.64514 18.8573 5.64514Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85718 21.0737H19.9029C20.3526 21.0756 20.7836 21.2542 21.1029 21.5709L23.1429 23.6452",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.857178 1.3595H2.57146C3.02612 1.3595 3.46216 1.54011 3.78365 1.8616C4.10514 2.18309 4.28575 2.61913 4.28575 3.07378V17.6452",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85718 20.6452C6.86565 20.7879 6.86565 20.931 6.85718 21.0737C6.80168 21.8443 6.44939 22.5632 5.87447 23.0793C5.29956 23.5953 4.54686 23.8681 3.77481 23.8404C3.00277 23.8126 2.27162 23.4864 1.73526 22.9304C1.1989 22.3744 0.89917 21.632 0.89917 20.8594C0.89917 20.0869 1.1989 19.3445 1.73526 18.7885C2.27162 18.2325 3.00277 17.9063 3.77481 17.8785C4.54686 17.8507 5.29956 18.1236 5.87447 18.6396C6.44939 19.1557 6.80168 19.8746 6.85718 20.6452V20.6452Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5713 12.5023H16.2856",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_27583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.502319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.3dc86cf970bc3a7db10d241ff00082b9.svg";
export { ForwardRef as ReactComponent };